<template>
    <span>
        <a href="#" @click.prevent="openModal">
            <slot></slot>
        </a>
        <i class="fi-info-circled text-navy" style="cursor: pointer;" @click="openModal" title="Finance details"></i>
    </span>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        'pcpInfo': Object,
        'hpInfo': Object,
    },
    methods: {
        openModal() {
            this.$modal.show('modal-finance-info', {pcp: this.pcpInfo, hp: this.hpInfo});
        },
    },
});
</script>
